<script>
export default {
  name: "LeadershipCouncilBanner",
};
</script>

<template>
  <div class="leadership-council-banner">
    <div class="leadership-council-banner__content">
      <h4>Лидерский и Предлидерский совет</h4>
      <p>
        Познакомьтесь с самыми успешными дистрибьюторами компании "Русский
        цифровой бизнес"
      </p>

      <a href="https://esd.docs-lab.ru/document/download/102" download>
        Открыть документ
        <span class="icon-arrow-outline-right" />
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.leadership-council-banner {
  width: 100%;
  background-color: $light-primary;
  border-radius: 8px;
  background-image: url("../assets/images/leadershi_council_background.png");
  background-size: contain;
  background-position: right center;
  background-repeat: no-repeat;

  &__content {
    max-width: calc(100% - 200px);
    padding: 32px;

    > h4 {
      @include body-1-bold;
      color: $dark-primary;
      margin-bottom: 8px;
    }

    > p {
      @include text-2;
      color: $dark-primary;
      margin-bottom: 24px;
    }

    > a {
      width: fit-content;
      @include text-2-bold;
      color: $dark-primary;
      display: flex;
      align-items: center;
      gap: 4px;

      > span {
        width: 8px;
        height: 8px;
        background-color: $dark-primary;
      }
    }
  }
}

@media (max-width: 900px) {
  .leadership-council-banner {
    &__content {
      padding: 20px;
      max-width: calc(100% - 152px);
    }
  }
}

@media (max-width: 575px) {
  .leadership-council-banner {
    background-image: none;

    &__content {
      padding: 20px;
      max-width: 100%;
    }
  }
}
</style>
